import React from 'react';
import DashboardCard from 'ui/DashboardCard/DashboardCard';
import RegulatoryContainer from './RegulatoryContainer';

const RegulatoryDirectives = () => (
  <DashboardCard fullHeight>
    <RegulatoryContainer />
  </DashboardCard>
);

export default RegulatoryDirectives;
